import React, { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import DataTableComponent from "../../../../../../Util/DataTable/DataTable";
import RateCard from "../../../../../../Util/RateCard/RateCard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Lead.css";
import { config } from "../../../../../../config";
import { EVENT_STATUS, LEAD_STATUS } from "../../../../../../Util/helper";
import axiosApi from "../../../../../../core/interceptor/interceptor";
import * as moment from 'moment';
import add from "../../../../../../assets/add-icon.svg";
import calendar from '../../../../../../assets/calendar-icon.svg';
import CustomSelect from "../../../../../../Util/CustomSelect/CustomSelect";

function Lead() {
  const LEADSTATUS = [
    {
      id: 'open',
      title: 'Open'
    },
    {
      id: 'in_progress',
      title: 'In Progress'
    },
    {
      id: 'approved',
      title: 'Approved'
    },
    {
      id: 'rejected',
      title: 'Rejected'
    },
  ];
  const columns = [
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}> Name</div>,
      selector: () => 'title',
      className: 'left-align',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.title ? `${row.title}` : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Start Date</div>,
      selector: () => 'start_date_time',
      minWidth: '160px !important',
      sortable: 'true',
      style: {
        padding: '0',
        whiteSpace: 'pre-wrap !important'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', justifyContent: 'flex-start !important', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.start_date_time ? moment(row.start_date_time).format('MM/DD/YYYY, hh:mm A') : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>End Date</div>,
      selector: () => 'end_date_time',
      minWidth: '160px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.end_date_time ? moment(row.end_date_time).format('MM/DD/YYYY, hh:mm A') : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Type</div>,
      selector: () => 'type',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.type ? EVENT_STATUS[row.type] : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Occasion</div>,
      selector: () => 'occasion',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.occasion ? row.occasion : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Client Name</div>,
      selector: () => 'client_name',
      minWidth: '136px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.client_name ? row.client_name : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Client Phone</div>,
      selector: () => 'client_phone',
      minWidth: '136px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.client_phone ? row.client_phone : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Venue</div>,
      selector: () => 'venue',
      minWidth: '136px !important',
      // sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row && row?.event_venue && row?.event_venue?.name ? row?.event_venue?.name : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Captured Date</div>,
      selector: () => 'captured_date_time',
      minWidth: '98px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.captured_date_time ? moment(row.captured_date_time).format('MM/DD/YYYY') : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word', minWidth: '150px' }}> Status</div>,
      selector: () => 'status',
      minWidth: '98px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>
        {
          row.status !== 'approved' ?
          <CustomSelect data={LEADSTATUS} placeholder={row.status ? LEAD_STATUS[row.status] : 'Open'} leadRejectReason={setReason} showConfirmation={true} onSelect={(e) => handleStatusChange(row?.id, {e, row})} menuPortalTarget={document.body} selector='title' />
          :
          'Approved'
        }
      </div>)
    },
  ];

  const history = useHistory();
  const [totalPage, setTotalPage] = useState(0);
  const [leads, setLeads] = useState([]);
  const [queryparam, setQueryparam] = useState({
    title: '',
    client_name: '',
    start_date_time: '',
    end_date_time: '',
    direction: 'desc',
    sort_column: 'id',
    page: 1,
    limit: 50,
  });
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [overview, setOverview] = useState({
    total: 0,
    open: 0,
    in_progress: 0
  });
  const [rejectReason, setRejectReason] = useState('');

  useEffect(() => {
    handleChange({
      target: {
        name: 'start_date_time',
        value: startDate
      }
    })
  }, [startDate]);

  useEffect(() => {
    handleChange({
      target: {
        name: 'end_date_time',
        value: endDate
      }
    })
  }, [endDate]);

  const handleChange = (e) => {
    // if (e.target.name === 'start_date_time') {
    //   setStartDate(e.target.value);
    // } else if (e.target.name === 'end_date_time') {
    //   setEndDate(e.target.value);
    // }
    let stateFunc = null;
    if (e.type === 'sort') {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.value,
        'direction': e.target.direction,
      })
    } else {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.name === 'start_date_time' ? e.target.value : e.target.name === 'end_date_time' ? e.target.value : String(e.target.value).trim(),
      })
    }
    setQueryparam(stateFunc);
  }

  const handleStatusChange = (id, data) => {
    if (id && data && data.e && data.e.id) {
      if (data.e.id === 'rejected') {
        data.row.reason = rejectReason;
        axiosApi.put(`${config.apiUrl}/leads/${id}/${data.e.id}`, data.row)
        .then((res) => {
          getLeads(queryparam);
          getOverview();
        })
      } else {
        axiosApi.put(`${config.apiUrl}/leads/${id}/${data?.e.id}`)
        .then((res) => {
          getLeads(queryparam);
          getOverview();
        }).catch((e) => {
          getLeads(queryparam);
        })
        .catch(() => {
          getLeads(queryparam);
        })
      }
    }
  }

  const getLeads = (params) => {
    axiosApi.get(`${config.apiUrl}/leads`, { params })
      .then((res) => {
        if (res && res.data && res.data.data && res.data.data.rows) {
          setLeads(res.data.data.rows);
        }
      })
  }

  const getOverview = () => {
    axiosApi.get(`${config.apiUrl}/leads/overview`)
      .then((res) => {
        if (res && res.data && res.data.data) {
          const data = res.data.data;
          setOverview({
            total: data[0].total,
            open: data[0].open,
            in_progress: data[0].in_progress,
            approved: data[0].approved,
            rejected: data[0].rejected,
          })
        }
      })
  }

  useEffect(() => {
    getLeads(queryparam);
    getOverview();
    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    getLeads(queryparam);
    //eslint-disable-next-line
  }, [queryparam.page, queryparam.limit, queryparam.direction, queryparam.sort_column])

  const handleSearch = (e) => {
    e.preventDefault();
    setQueryparam(() => ({
      ...queryparam,
      'page': 1,
      'direction': '',
      'sort_column': '',
    }))
    getLeads(queryparam);
  }

  /***** set reject reason callback from customselect */
  const setReason = (cb) => {
    setRejectReason(cb);
  }
  return (
    <>
      <div className={''}></div>
      <div className="user-wrapper">
        <div className="header-blk">
          <h2>Overview</h2>
        </div>
        <div className="cards-wrapper">
          <div className="cards-blk">
            <RateCard text='Total Leads' value={overview.total} />
            <RateCard text='Open Leads' value={overview.open} />
            <RateCard text='In Progress Leads' value={overview.in_progress} />
            <RateCard text='Rejected' value={overview.rejected} />
            <RateCard text='Approved' value={overview.approved} />
          </div>
        </div>
        <div className="search-blk search-blk-lead with-add-btn">
          <h2>Search</h2>
          <div className="lead-form-add-btn">
            <form onSubmit={handleSearch}>
              <div className="input-field">
                <label htmlFor="first_name">Title</label>
                <input type="text" id="title" name="title" onChange={handleChange} />
              </div>
              <div className="input-field">
                <label>Start Date</label>
                <div className="date-blk">
                  <DatePicker
                    placeholderText={'MM/DD/YYYY'}
                    selected={startDate}
                    clearButtonTitle={'Clear'}
                    isClearable={startDate ? true : false}
                    clearButtonClassName="clear-button"
                    onChange={(date) => setStartDate(date)}
                  />
                </div>
                {/* {!payload.start_date && formSubmitted && <span className="error">{messages.start_date_error}</span>} */}
              </div>
              {/* <div className="input-field">
              <label htmlFor="email">End Date</label>
              <input type="text" id="email" name="email" />
            </div> */}
              <div className="input-field">
                <label>End Date</label>
                <div className="date-blk">
                  <DatePicker
                    placeholderText={'MM/DD/YYYY'}
                    onKeyPress={(e) => console.log('light speed ',e)}
                    selected={endDate}
                    isClearable={endDate ? true : false}
                    clearButtonClassName="clear-button"
                    onChange={(date) => setEndDate(date)}
                  />
                </div>
                {/* {!payload.start_date && formSubmitted && <span className="error">{messages.start_date_error}</span>} */}
              </div>
              <div className="input-field">
                <label htmlFor="contact">Client Name</label>
                <input id="clientName" name="client_name" onChange={handleChange} />
              </div>
              <button type='submit'>Search</button>
            </form>
            <div className="right">
              <button onClick={() => history.push('leads/add')} ><img src={add} alt="" />Add Lead</button>
            </div>
          </div>
        </div>
      </div>
      <div className="table-wrapper">
        <div className="heading-blk">
          <div className="left">
            <h2>Results</h2>
            <p>Select a lead to view details.</p>
          </div>
        </div>
        <div className="dataTable ns-table-fix">
          <DataTableComponent key="table-admin-users"
            // loading={loader}
            type={'leads'}
            data={leads}
            columns={columns}
            onFilterChange={handleChange}
            totalPage={totalPage}
          // limit={userDetail.limit}
          // refresh={() => getUsers()} 
          />
        </div>
      </div>
    </>
  );
}

export default withRouter(Lead);
